var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIllMCloud = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--brand-primary-40, #0070FF)",
  d: "M18.558 14.19c.797-4.518 1.195-6.778 2.418-8.323a7.8 7.8 0 0 1 3.66-2.563c1.87-.62 4.13-.222 8.65.575l9.523 1.68c4.52.796 6.779 1.194 8.324 2.417a7.8 7.8 0 0 1 2.563 3.66c.62 1.87.222 4.13-.575 8.65l-1.68 9.523c-.796 4.52-1.194 6.779-2.417 8.324a7.8 7.8 0 0 1-3.66 2.563c-1.87.62-4.13.222-8.65-.575l-9.523-1.68c-4.52-.796-6.779-1.194-8.324-2.417a7.8 7.8 0 0 1-2.563-3.66c-.62-1.87-.222-4.13.575-8.65z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#ill-m-cloud_svg__a)",
  d: "M2 25.3c0-5.884 0-8.826 1.2-11.049A10 10 0 0 1 7.25 10.2C9.474 9 12.416 9 18.3 9h11.4c5.884 0 8.826 0 11.049 1.2A10 10 0 0 1 44.8 14.25C46 16.474 46 19.416 46 25.3v11.4c0 5.884 0 8.826-1.2 11.049A10 10 0 0 1 40.75 51.8C38.526 53 35.584 53 29.7 53H18.3c-5.884 0-8.826 0-11.049-1.2A10 10 0 0 1 3.2 47.75C2 45.526 2 42.584 2 36.7z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.7,
  d: "M19 23a8 8 0 0 1 7.696 5.82A6 6 0 1 1 31 39H19a8 8 0 1 1 0-16"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ill-m-cloud_svg__a",
  x1: 2,
  x2: 46,
  y1: 53,
  y2: 9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--brand-primary-10, #D5E7FF)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--brand-primary-40, #0070FF)"
})))));
export default SvgIllMCloud;